const WhatsappOptInRequestMessageV1 = ({ name }: { name: string }) => {
  return (
    <div className="flex flex-col items-center gap-y-1">
      <div className="grid w-72 grid-cols-2 gap-1">
        <div className="col-span-2 rounded-xl bg-white p-4">
          <div className="font-semibold">Unlock exclusive contents!</div>
          <div className="text-secondary text-sm">
            Want to get additional messages from {name}? You can opt out at any time.
          </div>
        </div>
        <div className="flex h-12 items-center justify-center rounded-xl bg-white font-semibold text-[#5CA7D8]">
          Allow
        </div>
        <div className="flex h-12 items-center justify-center rounded-xl bg-white font-semibold text-[#5CA7D8]">
          Cancel
        </div>
      </div>
    </div>
  );
};

export const WhatsappOptInRequestMessage = {
  Latest: WhatsappOptInRequestMessageV1,
  V1: WhatsappOptInRequestMessageV1,
};
